let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("gD9D1")).then(() => parcelRequire('fwLkx'));